export const VERTRAG_MAX_MITARBEITER = 500;
